<template>
  <hel-module title="供应商交期表现分布" :class="scope.clsPrefix" v-loading="loading">
    <div class="chart-container">
      <div class="chart-main">
        <div class="chart-body-wrap">
          <div class="chart-center-text">
            <div class="center-value">{{ onTimeRate }}%</div>
            <div class="center-label">准时率</div>
          </div>
          <div id="deliveryDistributionChart" class="chart-body"></div>
        </div>
        <div class="legend-list">
          <div class="legend-item" v-for="(item, index) in distribution" :key="index">
            <div class="item-header">
              <span class="item-dot" :style="{ background: item.color }"></span>
              <span class="item-name">{{ item.range }}</span>
            </div>
            <div class="item-value">{{ item.count }}单 · {{ item.percent }}%</div>
          </div>
        </div>
      </div>
    </div>
  </hel-module>
</template>

<script>
import HelModule from '../common/module/index.vue'
import * as echarts from 'echarts'
import { getSupplierDelivery } from '@/api/procurement'

export default {
  name: 'SupplierDeliveryDistribution',
  components: {
    HelModule
  },
  props: {
    data: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      loading: false,
      scope: {
        clsPrefix: 'rvc-cosmoplat-workspace-delivery-distribution'
      },
      totalOrders: 0,
      onTimeRate: '--',
      distribution: [],
      chartInstance: null
    }
  },
  mounted() {
    this.fetchData()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
    if (this.chartInstance) {
      this.chartInstance.dispose()
      this.chartInstance = null
    }
  },
  methods: {
    async fetchData() {
      this.loading = true
      try {
        const res = await getSupplierDelivery()
        if (!res || res.code !== 200 || !res.data) {
          this.totalOrders = 0
          this.onTimeRate = '--'
          this.distribution = []
          return
        }
        const data = res.data
        const colors = ['#7CB87C', '#6B7FD7', '#E8B87C']
        this.totalOrders = data.totalOrders || 0
        this.onTimeRate = data.onTimeRate != null ? data.onTimeRate : '--'
        const dist = Array.isArray(data.distribution) ? data.distribution : []
        this.distribution = dist.map((d, index) => ({
          range: d.bucketName,
          count: d.orderCount,
          percent: d.percent,
          color: colors[index % colors.length]
        }))

        this.$nextTick(() => {
          this.drawChart()
        })
      } catch (error) {
        console.error('获取供应商交期表现分布数据失败:', error)
        this.totalOrders = 0
        this.onTimeRate = '--'
        this.distribution = []
      } finally {
        this.loading = false
      }
    },
    drawChart() {
      const chart = echarts.init(
        document.getElementById('deliveryDistributionChart')
      )
      const option = {
        tooltip: {
          trigger: 'item',
          confine: true,
          formatter: (params) =>
            `${params.name}: ${params.value}单 (${params.percent}%)`
        },
        series: [
          {
            name: '订单数',
            type: 'pie',
            radius: ['65%', '100%'],
            center: ['50%', '50%'],
            avoidLabelOverlap: false,
            hoverAnimation: false,
            label: {
              show: false,
              position: 'center'
            },
            labelLine: {
              show: false
            },
            data: this.distribution.map((item) => ({
              value: item.count,
              name: item.range,
              itemStyle: {
                color: item.color
              }
            }))
          }
        ]
      }
      chart.setOption(option)
      this.chartInstance = chart
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          this.chartInstance && this.chartInstance.resize()
        })
        setTimeout(() => {
          this.chartInstance && this.chartInstance.resize()
        }, 200)
      })
    },
    handleResize() {
      if (this.chartInstance) {
        setTimeout(() => {
          this.chartInstance.resize()
        }, 200)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$class-prefix: "rvc-cosmoplat-workspace-delivery-distribution";
.#{$class-prefix} {
  .chart-container {
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 10px 0;
    box-sizing: border-box;
  }
  .chart-main {
    flex: 1;
    display: flex;
    align-items: center;
    min-height: 0;
  }
  .chart-body-wrap {
    position: relative;
    width: 55%;
    height: 100%;
    min-height: 220px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .chart-center-text {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    z-index: 1000;
    .center-label {
      font-family: PingFangSC-Medium;
      font-weight: 600;
      font-size: 11px;
      color: #333333;
    }
    .center-value {
      font-size: 18px;
      font-weight: 700;
      color: #333;
    }
  }
  .chart-body {
    width: 100%;
    height: 100%;
    min-height: 220px;
  }
  .legend-list {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 14px;
    padding-left: 12px;
    flex-shrink: 0;
    min-width: 40%;
  }
  .legend-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
  }
  .item-header {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .item-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
  }
  .item-name {
    font-size: 12px;
    color: #666666;
    font-weight: 400;
  }
  .item-value {
    font-size: 12px;
    color: #333333;
    font-weight: 600;
  }
}
</style>
